/* eslint-disable import/no-extraneous-dependencies */
import * as React from 'react';
import { Alert } from '@tvg/fuse-design';

interface Props {
  title: string;
}
export function InsuranceNotification({ title }: Props) {
  return (
    <div>
      <Alert
        variant="information"
        message={`Please select item options before ${title}.`}
        dataTestId="insurance-notification"
      />
    </div>
  );
}

export default InsuranceNotification;
